import { render, staticRenderFns } from "./adSeries.vue?vue&type=template&id=20271d02&scoped=true&"
import script from "./adSeries.vue?vue&type=script&lang=js&"
export * from "./adSeries.vue?vue&type=script&lang=js&"
import style0 from "./adSeries.vue?vue&type=style&index=0&id=20271d02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20271d02",
  null
  
)

export default component.exports